import React from 'react';

import {CommonProvider} from '@yandex-data-ui/common';
import {Provider} from 'react-redux';
import ErrorBoundary from 'ui/components/ErrorBoundary';
import store, {selectors, useAppSelector} from 'ui/store';

const {selectTheme} = selectors;

const withCommon = <P extends {}>(Component: React.FC<P>) =>
    function WithCommonProvider(props: P) {
        const theme = useAppSelector(selectTheme);

        return (
            <CommonProvider theme={theme}>
                <Component {...props} />
            </CommonProvider>
        );
    };

const withErrorBoundary = <P extends {}>(Component: React.FC<P>) =>
    function WithErrorBoundaryProvider(props: P) {
        return (
            <ErrorBoundary>
                <Component {...props} />
            </ErrorBoundary>
        );
    };

const withRedux = <P extends {}>(Component: React.FC<P>) =>
    function WithReduxProvider(props: P) {
        return (
            <Provider store={store}>
                <Component {...props} />
            </Provider>
        );
    };

export const withAppProviders = <Props extends object>(Component: React.FC<Props>) => {
    return withErrorBoundary(withRedux(withCommon(Component)));
};
